import { useEffect, useState } from 'react';
import { AlloyButton, Input, AlloyIcon } from 'cat-ecommerce-alloy';
import PropTypes from 'prop-types';
import { Field } from 'formik';
import { useTranslation } from 'react-i18next';
import cx from 'classnames';
import { useSelector } from 'react-redux';
import { ICON_WIDTH, ICON_HEIGHT } from '../../constants';
import { copyToClipboard } from '../../../../utils';
import styles from './ShareCartChildModal.module.scss';

const ShareCartChildModal = ({ childClose, close }) => {
  const [t] = useTranslation();
  const [copyLink, setCopyLink] = useState(false);
  const deepLinkUrl = useSelector(s => s.checkout?.deepLinkUrl);
  const handleCopy = () => {
    setCopyLink(copyToClipboard(deepLinkUrl));
  };
  useEffect(() => {
    document.addEventListener('copy', handleCopy);
    return () => document.removeEventListener('copy', handleCopy);
  }, []);

  return (
    <>
      <div
        className={cx(
          'd-flex flex-column mb-4 position-relative',
          styles['share-child-modal__form-container']
        )}
      >
        <div className="d-md-flex p-0 mb-1">
          <Field
            as={Input}
            readOnly
            value={deepLinkUrl}
            formGroupClassname={cx(
              'w-100 mb-3 mb-md-0',
              styles['share-cart-modal__url-input']
            )}
            className="u-color--MediumBlue u-fs-lg--14 u-fs-sm--16 p-0"
          />
          <AlloyButton
            buttonType="secondary"
            className="text-univers--bold"
            onClick={handleCopy}
          >
            {t('COPY')}
          </AlloyButton>
        </div>
        {copyLink && (
          <div
            className={cx('d-flex align-items-center', styles['link-copied'])}
          >
            <AlloyIcon
              icon="icon-check"
              title=""
              className="u-fill--DarkGreen me-1"
              width={ICON_WIDTH}
              height={ICON_HEIGHT}
            />
            <span className="m-0 u-color--DarkGreen u-fs--12">
              {t('LINK_COPIED')}
            </span>
          </div>
        )}
      </div>
      <div className="d-flex flex-column flex-lg-row">
        <AlloyButton
          className="mb-lg-0 mb-1"
          buttonType="secondary"
          onClick={close}
        >
          {t('DONE')}
        </AlloyButton>
        {childClose && (
          <AlloyButton
            className="m-lg-0 mt-2"
            buttonType="ghost"
            onClick={() => childClose()}
          >
            {t('BACK')}
          </AlloyButton>
        )}
      </div>
    </>
  );
};

ShareCartChildModal.propTypes = {
  close: PropTypes.func.isRequired,
  childClose: PropTypes.func
};

export default ShareCartChildModal;
